import { render, staticRenderFns } from "./realMonitoring.vue?vue&type=template&id=990f015c&scoped=true"
import script from "./realMonitoring.vue?vue&type=script&lang=js"
export * from "./realMonitoring.vue?vue&type=script&lang=js"
import style0 from "./realMonitoring.vue?vue&type=style&index=0&id=990f015c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f015c",
  null
  
)

export default component.exports